import type { Customer, PaymentMethodDtoWithIsPreferred, RulePayer } from 'korint-sdk';

/**
 * Pairs each billed customer with its own payment methods, so a validation rule reads the
 * payers rather than the policy's first customer.
 *
 * Returns undefined while the payer set is incomplete — payer ids not yet resolved or a payer's
 * customer query still loading — so callers fail closed instead of judging a partial list as
 * "every payer settles offline".
 */
export function buildRulePayers({
  customerIds,
  payerCustomerIds,
  customers,
  paymentMethods,
}: {
  customerIds: string[];
  payerCustomerIds: string[];
  customers: Array<{ data?: Customer }>;
  paymentMethods: Array<{ data?: PaymentMethodDtoWithIsPreferred[] }>;
}): RulePayer[] | undefined {
  // A policy always bills at least one payer; an empty set means resolution has not finished
  if (payerCustomerIds.length === 0) {
    return undefined;
  }

  const payers: RulePayer[] = [];

  for (const payerCustomerId of payerCustomerIds) {
    const index = customerIds.indexOf(payerCustomerId);
    const customer = customers[index]?.data;

    if (!customer) {
      return undefined;
    }

    payers.push({ customer, paymentMethods: paymentMethods[index]?.data ?? [] });
  }

  return payers;
}
